import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import StatusBar from "./StatusBar";

const NavigationButtons = ({ onBackClick, onNextClick, stepPosition }) => {
	return (
		<Grid container>
			<Grid item xs={12} sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
				<Button
					variant="outlined"
					onClick={onBackClick}
					startIcon={<ArrowBackIcon />}
					sx={{
						flexShrink: 0,
						minWidth: "100px",
						paddingY: 0.75,
						paddingX: 1.5,
						fontSize: "1rem",
						fontWeight: 500
					}}
				>
					Back
				</Button>
				<Box sx={{ flexGrow: 1, marginX: 3 }}>
					<StatusBar stepPosition={stepPosition} />
				</Box>
				<Button
					variant="outlined"
					onClick={onNextClick}
					endIcon={<ArrowForwardIcon />}
					sx={{
						flexShrink: 0,
						minWidth: "100px",
						paddingY: 0.75,
						paddingX: 1.5,
						fontSize: "1rem",
						fontWeight: 500
					}}
				>
					Next
				</Button>
			</Grid>
		</Grid>
	);
};

export default NavigationButtons;
